import sessionService from '../../api/session'
import router from '../../router'

const state = {
}
const mutations = {
}

const actions = {
  logout ({ commit, dispatch,catalogue }) {
    const token = localStorage.getItem('token')
    if (token === null || token === 'null') {
      router.push('/login')
    }
    sessionService.logout(token).then(response => {
      commit('SET_USER', null)
      commit('SET_TOKEN', null)
      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
      }
      state.loggedIn = false
      router.push(response.data.redirect ? response.data.redirect : '/login')
      // dispatch('notification/resetNotifications', {}, { root: true })
      dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message ? response.data.message : 'Success' }, { root: true })
      catalogue('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message ? response.data.message : 'Success' }, { root: true })
    }).catch(error => {
      dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' }, { root: true })
      catalogue('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' }, { root: true })
    })
    
  },
  switchAccount ({ commit }, org) {
    commit('SET_USER', {})
    return new Promise((resolve, reject) => {
      sessionService.switchAccount(org).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
